import { render, staticRenderFns } from "./info-intro.vue?vue&type=template&id=76d52c08&scoped=true&"
import script from "./info-intro.vue?vue&type=script&lang=js&"
export * from "./info-intro.vue?vue&type=script&lang=js&"
import style0 from "./info-intro.vue?vue&type=style&index=0&id=76d52c08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d52c08",
  null
  
)

export default component.exports